import { render, staticRenderFns } from "./EducationItem.vue?vue&type=template&id=036770be&"
import script from "./EducationItem.vue?vue&type=script&lang=ts&"
export * from "./EducationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports